export interface EthnicityModel {
  doNotWishToProvideInformation?: boolean;
  ethnicityCombination?: number[];
  ethnicityCompleted?: number;
  hispanicOrLatino?: HispanicOrLatinoModel;
}

export interface GenderModel {
  doNotWishToProvideInformation?: boolean;
  isFemale?: boolean;
  isMale?: boolean;
  genderCompleted?: number;
}

export interface GovernmentMonitorModel {
  borrowerId?: number;
  borrowerName?: string;
  isPrimaryBorrower?: boolean;
  creditScoreMedian?: string;
  ethnicity?: EthnicityModel;
  infoProvidedVia?: number;
  loanStatus?: string;
  militaryService?: MilitaryServiceModel;
  race?: RaceModel;
  gender?: GenderModel;
  wishToProvideInformation?: boolean;
  supplementalConsumerInformation?: SupplementalConsumerInformation;
}

export type SupplementalConsumerInformation = {
  housingCounselingAgencyId: string;
  housingCounselingAgencyName: string;
  housingCounselingCompleted: IsComplete;
  housingEducationCompletionDate: Date;
  housingCounselingCompletionDate: Date;
  housingCounselingFormat: CounselingFormat;
  housingEducationAgencyId: string;
  housingEducationAgencyName: string;
  housingEducationCompleted: IsComplete;
  housingEducationFormat: EducationFormat;
  languagePreference: LanguagePreference;
  languageOtherDescription: string;
};

export interface HispanicOrLatinoModel {
  isCuban?: boolean;
  isHispanicOrLatino?: boolean;
  isMexican?: boolean;
  isNotHispanicOrLatino?: boolean;
  isOtherHispanicOrLatino?: boolean;
  isPuertoRican?: boolean;
  otherHispanicOrLatinoDescription?: string;
}

export interface MilitaryServiceModel {
  hasMilitaryService?: boolean;
  isMilitaryActiveDuty?: boolean;
  isMilitaryReservesOrNationalGuard?: boolean;
  isMilitarySurvivingSpouse?: boolean;
  isRetiredService?: boolean;
  militaryServiceExpirationDate?: Date;
}

export interface RaceModel {
  doNotWishToProvideInformation?: boolean;
  isAmericanIndianOrAlaskaNative?: boolean;
  isAsian?: boolean;
  isAsianIndian?: boolean;
  isBlackOrAfricanAmerican?: boolean;
  isChinese?: boolean;
  isFilipino?: boolean;
  isGuamanianOrChamorro?: boolean;
  isJapanese?: boolean;
  isKorean?: boolean;
  isNativeHawaiian?: boolean;
  isNativeHawaiianOrPacific?: boolean;
  isOtherAsian?: boolean;
  isOtherPacificIslander?: boolean;
  isSamoan?: boolean;
  isVietnamese?: boolean;
  isWhite?: boolean;
  otherAsianDescription?: string;
  otherPacificIslanderDescription?: string;
  raceCombination?: number[];
  raceCompleted?: number;
  tribeDescription?: string;
}

// OBSOLETE?
export interface GovernmentMonitoringInformationModel {
  applicationId?: number;
  governmentMonitorList?: GovernmentMonitorModel[];
  applicationMethod?: number;
  channel?: number;
  companyAddress?: string;
  companyGenratedLead?: boolean;
  companyIdentifier?: string;
  date?: Date;
  fileDataId?: number;
  fileName?: string;
  identifier?: string;
  infoWasProvided?: string;
  jrloName?: string;
  licenseNo?: string;
  loanId?: number;
  mortgageType?: number;
  name?: string;
  organizationId?: number;
  phoneNumber?: string;
  prequalDate?: string;
  retailLeadType?: number;
  retailLoCompPlan?: number;
  userId?: number;
}

export enum LanguagePreference {
  Select = 0,
  English = 1,
  Chinese = 2,
  Korean = 3,
  Spanish = 4,
  Tagalog = 5,
  Vietnamese = 6,
  Other = 7,
  NoResponse = 8,
}

export enum CounselingFormat {
  NotAssigned = 0,
  FaceToFace = 1,
  Telephone = 2,
  Internet = 3,
  Hybrid = 4,
}

export enum EducationFormat {
  NotAssigned = 0,
  AttendedWorkshopInPerson = 1,
  CompletedWebBasedWorkshop = 2,
}

export enum IsComplete {
  None = 0,
  Yes = 1,
  No = 2,
}
